@if (apple()?.isSupervised) {
  <div ngbDropdown
       placement="bottom-right"
       class="btn-group">
    <button ngbDropdownToggle
            type="button"
            [class]="class()">
      <fa-icon icon="power-off"></fa-icon>
    </button>
    <div ngbDropdownMenu
         class="dropdown-menu dropdown-menu-end">
      @if (apple() | os: { iOS: '>=10.3', macOS: '>=10.13', appleTV: '>=10.3' }) {
        <ml-mdm-restart-device-dropdown-item [apple]="apple()"
                                             [class]="'dropdown-item'">Restart</ml-mdm-restart-device-dropdown-item>
      }
      @if (
    (apple() | os: { iOS: '>=10.3', macOS: '>=10.13', appleTV: '>=10.3' }) &&
    (apple() | os: { iOS: '>=10.3', macOS: '>=10.13' })
    ) {
        <div class="dropdown-divider"></div>
      }
      @if (apple() | os: { iOS: '>=10.3', macOS: '>=10.13' }) {
        <ml-mdm-shutdown-device-dropdown-item [apple]="apple()"
                                              [class]="'dropdown-item'"> Shutdown</ml-mdm-shutdown-device-dropdown-item>
      }
    </div>
  </div>
}